import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import {
    COMPANY_FETCH_URL,
  WORKER_TYPES_URL,
  BANNER_TITLE_URL,
  POLICY_DETAILS_URL,

} from "../../../configs/constants";
import Table from "components/Table";
import Filter from "@Components/Filter";
import { IconButton } from "@material-ui/core";
import ExcelLogo from "assets/img/excel_icon.svg";
import PdfLogo from "assets/img/pdf_icon.svg";
let model = [
    { id: "worker_id", label: "Worker ID", type: "string" },
    { id: "name", label: "Name", type: "string" },
    { id: "company", label: "Company", type: "string" },
    { id: "zone", label: "Zone", type: "string"  },
    { id: "region", label: "Region", type: "string"  },
    { id: "estate", label: "Estate", type: "string"  },
    { id: "nationality", label: "Nationality", type: "string" },
    { id: "submitted_date", label: "Submitted Date", type: "date" },
    { id: "remarks", label: "Remark", type: "string" },
    
    
  ];




// const filterInitialValues = {
//   date: null,
//   employee_id: "",
//   name: "",
//   company: "",
//   zone: "",
//   region: "",
//   estate: "",
// };

const policyDetails = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
 

  const details = useLocation();
  const URLS = {
    POLICY_LOG: "/report/policy-detailed/",
  };
  const today = new Date();
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');

  const filterFields = [

    {
        type: "reactselect",
        name: "banner",
        label: "Policy Title",
        required: true,
        proxyUrl: BANNER_TITLE_URL,
        paginated: false,
  
      },
     
    {
        type: "reactselect",
        name: "worker-type",
        label: "Worker Type",
        proxyUrl: WORKER_TYPES_URL,
        paginated: false,
  
      },
      {
        type:"reactselect",
        name: "status",
        key: "status",
        label: "Policy Status",
        outerOptions: [
          { id: "All", name: "All" },
          { id: "1", name: "Agree" },
          { id: "0", name: "Disagree" },
        ],
      },
      {
        type: "reactselect",
        name: "company",
        label: "Company",
        proxyUrl: COMPANY_FETCH_URL,
        paginated: true,
        
  
      },
    
    
 
    
    
    
  ];


  const validationSchema = Yup.object({
    banner: Yup.string().required("Policy Title is required").typeError("Policy Title is required"),

  });
  const filterInitialValues = {

  };
 

  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
 
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        validationSchema={validationSchema}
        onClear={clearFilter}


      />
      <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
                  

        </div>
        {filtersApplied ? (

<Table
proxyURL={POLICY_DETAILS_URL}
model={model}
filterValues={filterValues}
noFilter
noAddButton
excelExport={{ fileName: "PolicyDetailReport" }}
pdfExport={{ fileName: "PolicyDetailReport" }}
disableLabelDisplayedRows = {true}
tableBodyDisable = {true}
paginationDisable = {true}

/>
) : (
  <Table
  proxyURL={null}
  model={model}
  filterValues={filterValues}
  noFilter
  noAddButton
  excelExport={{ fileName: "PolicyDetailReport" }}
  pdfExport={{ fileName: "PolicyDetailReport" }}
  disableLabelDisplayedRows = {true}
  tableBodyDisable = {true}
  paginationDisable = {true}
/>
)}

       
     

    </>
  );
};
export default policyDetails;

